import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';

import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { sortArrayHacksawGames } from './data';
import { getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

export interface IHacksawServerGame {
  gameId: number;
  gameName: string;
  gameStudioName: string;
  type: CasinoType;
  gameStudioShortName: string;
  gameType: string;
  betLevels: number[];
  rtpVariations: {
    isDefault: boolean;
    variation: number;
    theoreticalRTP: number;
  }[];
  jackpot: {
    jackpotName: string;
    jackpotSizeCents: number;
  } | null;
  maxWinMultiplier: number;
  releaseDate: string;
  bonusBuyOptions: any[];
}

export interface IHacksawSessionResponse {
  url: string;
}

class Converter implements ISlotConverter {
  convertGameList = ({ data, extraData, platform }: IConvertGameList<any>): ISlotViewItem[] => {
    const games = data as IHacksawServerGame[];

    return games
      .map(
        (game: IHacksawServerGame): ISlotViewItem => ({
          id: String(game.gameId),
          gameId: game.gameId,
          description: game.gameName,
          gameName: game.gameName,
          format: undefined,
          sectionId: undefined,
          tab: getTab(game.gameId),
          type: CasinoType.slots,
          provider: 'hacksaw',
          imageUrl: `/images/hacksaw/${game.gameId}.png`,
          routeProvider: 'hacksaw',
        }),
      )
      .sort(
        (j, k) =>
          (sortArrayHacksawGames.indexOf(j.id as string) + 1 || Infinity - 1) -
          (sortArrayHacksawGames.indexOf(k.id as string) + 1 || Infinity),
      );
  };

  convertGameUrl = ({ data }: IGetGameUrl<IHacksawSessionResponse, unknown>): string => data.url;
}
export default Converter;
